export const date = value => {
  const dateObj = new Date(value)
  const day = `0${dateObj.getDate()}`.substr(-2)
  const month = `0${dateObj.getMonth() + 1}`.substr(-2)
  const year = dateObj.getFullYear()
  const formattedDob = `${day}/${month}/${year}`
  return formattedDob
}

export const currency = (value, noDecimal) => {
  // let formattedCurrency = parseInt(Intl.NumberFormat().format(value))
  // formattedCurrency = `RM ${formattedCurrency.toFixed(2)}`
  const result = noDecimal ? `RM ${value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace('.00', '')}`
    : `RM ${value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
  return result
}

export const getAge = (dobString) => {
  if (!dobString || typeof dobString !== 'string') return null;

  const [day, month, year] = dobString.split('/').map(Number);

  const today = new Date();
  const birthDate = new Date(year, month - 1, day);

  let age = today.getFullYear() - birthDate.getFullYear();

  const monthDiff = today.getMonth() - birthDate.getMonth();
  const dayDiff = today.getDate() - birthDate.getDate();

  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--;
  }

  return age;
}

export default {
  date,
  currency
}